// Extracts image type from filename
export const extractSortDetails = (
    imageUrl: string
): {
    sortNumber: number | null;
    sortLetter: string | null;
    imageType: string | null;
} => {
    if (!imageUrl) return { sortNumber: null, sortLetter: null, imageType: null };

    const parts = imageUrl.split("/");
    const filename = parts[parts.length - 1] || "";
    const folderName = parts[parts.length - 2] || "";

    // 🧠 Default imageType derived from folder name
    let imageType = folderName.includes("img_bgr")
        ? "img_bgr"
        : folderName || null;

    const filenameParts = filename.split("-");
    const sortNumber = parseInt(filenameParts[1]);
    const sortLetter = filenameParts[2] || null;

    return { sortNumber, sortLetter, imageType };
};
